import React from "react";
import styled from "styled-components";
import ContainerDefault from "./Containers/ContainerDefault";
import { Link } from "react-router-dom";
import media from "Styles/media";
import BtnIcon from "./Btn/BtnIcon";
import { useHeaderState } from "Provider/AppProvider";
import Logo from "./Logo";

const Wrapper = styled.header<{ hide: boolean; scroll: boolean; disable: boolean }>`
	border: 2px solid red;
	border-color: transparent;
	border-width: 0px;
	position: fixed;
	padding: ${(props) => `${props.theme.size.offset.pc}px 0`};
	width: 100%;
	z-index: ${(props) => props.theme.zIndex.header};
	transition: ${(props) => props.theme.transition.default};
	transition-property: transform;
	transform: ${(props) => `translateY(${props.hide ? -100 : 0}%)`};
	overflow: hidden;

	/* disable when popup */
	${(props) => (props.disable ? props.theme.event.disable : props.theme.event.able)}

	&:before {
		content: "";
		display: block;
		position: absolute;
		width: 100%;
		left: 0;
		top: 0;
		height: 100%;
		background-color: ${(props) => props.theme.color.bg};
		transition: ${(props) => props.theme.transition.default};
		opacity: ${(props) => (props.scroll ? 1 : 0)};
		border-bottom: 1px solid ${(props) => props.theme.color.gray.light};
		transition-property: opacity;
		box-sizing: border-box;
	}

	@media ${media.tablet} {
		padding: ${(props) => `${props.theme.size.offset.tablet}px 0`};
	}
`;

const Container = styled(ContainerDefault)`
	height: 100%;
`;

const Inner = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-between;
	position: relative;
`;

const Col = styled.div`
	display: flex;
	align-items: center;
`;

const ColAbout = styled(Col)`
	display: none;
	@media ${media.mobile} {
		display: flex;
	}
`;

const GnbWrapper = styled.div`
	${(props) => props.theme.layout.center_flex};
	width: ${(props) => `${props.theme.size.logo.pc}px`};

	@media ${media.tablet} {
		width: ${(props) => `${props.theme.size.logo.tablet}px`};
	}
`;

const Header: React.FC = () => {
	const {
		headerState: { solid, hide, disable }
	} = useHeaderState();

	return (
		<Wrapper hide={hide} scroll={solid} disable={disable}>
			<Container>
				<Inner>
					<Col>
						<Link to={"/"}>
							<Logo />
						</Link>
					</Col>
					<ColAbout>
						<GnbWrapper>
							<Link to={"/about"}>
								<BtnIcon icon="project" />
							</Link>
						</GnbWrapper>
					</ColAbout>
				</Inner>
			</Container>
		</Wrapper>
	);
};

export default Header;
